import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { signOut, fetchAuthSession } from 'aws-amplify/auth';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Onboarding from './components/Onboarding';
import BillingRedirect from './components/BillingRedirect';
import './aws-config';

function App() {
  const [user, setUser] = useState(null);
  const [reseller, setReseller] = useState(null);
  const [loading, setLoading] = useState(true);
  const [fetchingReseller, setFetchingReseller] = useState(false);

  useEffect(() => {
    // Check for existing session
    const savedUser = localStorage.getItem('partner_user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (user) {
      fetchResellerProfile();
    }
  }, [user]);

  const fetchResellerProfile = async () => {
    setFetchingReseller(true);
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      
      const response = await fetch(`${process.env.REACT_APP_API_URL}/profile`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        setReseller(data);
      }
    } catch (error) {
      console.error('Failed to fetch reseller profile:', error);
    } finally {
      setFetchingReseller(false);
    }
  };

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem('partner_user', JSON.stringify(userData));
    localStorage.setItem('partner_token', userData.token);
  };

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (e) {
      console.error('Sign out error:', e);
    }
    setUser(null);
    setReseller(null);
    localStorage.removeItem('partner_user');
    localStorage.removeItem('partner_token');
  };

  if (loading || fetchingReseller) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Login onLogin={handleLogin} />;
  }

  if (reseller?.status === 'pending') {
    return <Onboarding reseller={reseller} onComplete={() => window.location.reload()} />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<Dashboard user={user} reseller={reseller} onLogout={handleLogout} />} />
        <Route path="/billing" element={<BillingRedirect />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;